/*
 * art-mega-menu — additive, SHOP-NEUTRALE Erweiterung von Horizons Mega-Menü.
 * Wird nur geladen, wenn die Theme-Einstellung „Mega-Menü-Akzentpunkte" aktiv ist
 * (opt-in; andere Shops bleiben unberührt). Greift NICHT in Horizons Markup ein.
 *   1) Setzt vor jeden Unter-Link einen kleinen Akzent-Farbpunkt — die Farbe ROTIERT durch die
 *      Akzent-Palette (var(--art-*)), es gibt KEINE shop-/produktspezifische Zuordnung.
 *   2) Ergänzt eine schlichte, neutrale Kopfzeile mit Sammel-Link. Beide Beschriftungen kommen
 *      als data-Attribut vom <script>-Tag (aus Theme-Einstellungen bzw. `actions.view_all`) —
 *      im Skript stehender Text waere in keiner Sprache uebersetzbar.
 * Horizon rendert Menü-Links teils verzögert; daher re-runnt das Skript kurz (stoppt selbst)
 * und dekoriert beim ersten Hover/Focus im Header nach.
 */
(function () {
  // Neutrale, rotierende Akzentfarben (aus den Theme-Einstellungen). Keine Produktnamen.
  var ACCENTS = [
    'var(--art-terracotta)', 'var(--art-mustard)', 'var(--art-teal)',
    'var(--art-rose)', 'var(--art-blue)', 'var(--art-sage)', 'var(--art-brown)'
  ];
  /* Kopfzeile: Beschriftungen kommen aus dem <script>-Tag, das `art-globals.liquid` schreibt.
     Fest im Skript waeren sie unuebersetzbar — ein Asset erreicht weder Sprachdateien noch
     Theme-Einstellungen. Fehlt das Tag (aelterer Cache), bleibt die Kopfzeile einfach weg,
     statt eine fremdsprachige Zeile einzublenden. */
  var el = document.getElementById('art-mega-menu');
  var HEAD = {
    kicker: (el && el.dataset.kicker) || '',
    linkLabel: (el && el.dataset.linkLabel) || '',
    linkHref: (el && el.dataset.linkHref) || ''
  };

  function addDots() {
    document.querySelectorAll('.mega-menu__link').forEach(function (a) {
      if (a.classList.contains('mega-menu__link--parent')) return; // Überschriften auslassen
      if (a.querySelector('.mega-menu__link-image')) return;       // Bild-Links auslassen
      if (a.querySelector('.art-mega-dot')) return;                // schon dekoriert
      var grid = a.closest('.mega-menu__grid');
      var n = grid ? grid.querySelectorAll('.art-mega-dot').length : 0;
      var dot = document.createElement('span');
      dot.className = 'art-mega-dot';
      dot.style.background = ACCENTS[n % ACCENTS.length];
      a.insertBefore(dot, a.firstChild);
    });
  }

  // Grids, die bereits Farbpunkte tragen (= dekorierte Mega-Menüs).
  function dottedGrids() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.mega-menu__grid'),
      function (g) { return g.querySelector('.art-mega-dot'); }
    );
  }

  function addHead() {
    if (!HEAD.kicker && !HEAD.linkLabel) return;
    dottedGrids().forEach(function (grid) {
      if (grid.querySelector('.art-mega-head')) return;
      var head = document.createElement('div');
      head.className = 'art-mega-head';
      /* textContent statt innerHTML fuer die beiden Beschriftungen: sie stammen aus
         Einstellungen bzw. Uebersetzungen, also aus Text — nicht aus Markup. */
      if (HEAD.kicker) {
        var kicker = document.createElement('span');
        kicker.className = 'art-mega-kicker';
        kicker.textContent = HEAD.kicker;
        head.appendChild(kicker);
      }
      if (HEAD.linkLabel && HEAD.linkHref) {
        var link = document.createElement('a');
        link.className = 'art-mega-all';
        link.href = HEAD.linkHref;
        link.textContent = HEAD.linkLabel + ' ';
        var caret = document.createElement('i');
        caret.className = 'ph ph-arrow-right';
        caret.setAttribute('aria-hidden', 'true');
        link.appendChild(caret);
        head.appendChild(link);
      }
      grid.insertBefore(head, grid.firstChild);
    });
  }

  function run() { addDots(); addHead(); }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(run);
  document.addEventListener('shopify:section:load', run);

  var tries = 0;
  var iv = setInterval(function () {
    run();
    if (document.querySelector('.art-mega-dot') || ++tries > 24) clearInterval(iv);
  }, 250);

  function onEnter(e) {
    if (e.target.closest && e.target.closest('header, .header, .header-menu, .menu-list, nav')) run();
  }
  document.addEventListener('pointerover', onEnter, true);
  document.addEventListener('focusin', onEnter, true);
})();
